import { render, staticRenderFns } from "./GameShowConfigPreview.vue?vue&type=template&id=6e97d7a2&scoped=true"
import script from "./GameShowConfigPreview.vue?vue&type=script&lang=js"
export * from "./GameShowConfigPreview.vue?vue&type=script&lang=js"
import style0 from "./GameShowConfigPreview.vue?vue&type=style&index=0&id=6e97d7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97d7a2",
  null
  
)

export default component.exports